module.exports = __webpack_public_path__ + "static/media/spinner.a9842492.svg";